import { render } from "./Spot.vue?vue&type=template&id=04f2f7ee"
import script from "./Spot.vue?vue&type=script&lang=js"
export * from "./Spot.vue?vue&type=script&lang=js"

import "./Spot.vue?vue&type=style&index=0&id=04f2f7ee&lang=scss"

import exportComponent from "C:\\development\\AdmicomWeb\\AdmicomWeb.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__